import React from "react";
import { useCallStatus } from "../../call-details/CallStatusProvider";
import { PERSON_CD_MEMBER } from "../../constants";

const CallStatus = () => {
  const { attendees } = useCallStatus();
  const joinedAttendees = attendees.filter(({ status }) => status === "JOINED");

  const attendeeNames = joinedAttendees.map(({name, roleCd}) => {
    return roleCd === PERSON_CD_MEMBER ? `Patient ${name}` : name;
  }).join(", ");

  return (
    <div className="call-status">
      <p>
        {joinedAttendees.length === 0 ? (
          `No one is on the call`
        ) : (
          `${attendeeNames} ${joinedAttendees.length > 1 ? "are" : "is"} on the call.`
        )}
      </p>
    </div>
  );
};

export default CallStatus;
